export enum AuthActionTypes {
  SIGN_IN = "SIGN_IN",
  SIGN_OUT = "SIGN_OUT",
  SIGN_IN_REQUEST = "SIGN_IN_REQUEST",
  SIGN_IN_FAILURE = "SIGN_IN_FAILURE",
  SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS",
  GET_API_KEY = "GET_API_KEY",
  GET_API_KEY_SUCCESS = "GET_API_KEY_SUCCESS"
}
